import React from 'react'
import { BlockWrapper, defineBlock, smartProps } from '@smartfire/js-block-engine'
import { useCompetitionProps } from '../../hooks/useCompetitionProps'
import type { Row } from './data'
import { StatsJoueursDataProvider } from '../../contexts/StatsJoueursDataContext'
import { JoueurTypeSelector } from './JoueurTypeSelector'
import { Header } from './Header'
import { SortBySelector } from './SortBySelector'
import { JoueurSearchInput } from './JoueurSearchInput'
import { Pagination } from './Pagination'
import { SinglePage } from './SinglePage'
import styles from './styles.module.scss'

interface Attributes {
    rowsData: Row[]
}

const StatsJoueurs = (attributes) => {
    const {
        attributes: { rowsData },
        params: { ext_poule_id, ext_equipe_id },
    } = useCompetitionProps<Attributes>({
        initDataFromPhpFirstRendering: attributes,
    })

    return (
        <StatsJoueursDataProvider
            extPouleId={ext_poule_id}
            extEquipeId={ext_equipe_id}
            rowsData={rowsData}
        >
            <div className={styles.filterGroup}>
                <JoueurTypeSelector />
                <JoueurSearchInput />
                <SortBySelector />
            </div>
            <Header />
            <SinglePage />
            <Pagination />
        </StatsJoueursDataProvider>
    )
}

const StatsJoueursBlock = (attributes) => (
    <BlockWrapper.Without>
        <StatsJoueurs {...attributes} />
    </BlockWrapper.Without>
)

export default defineBlock({
    Block: StatsJoueursBlock,
    smartProps: {
        saisonFromQuery: smartProps.string.withDefault('').contentServerSide(),
    },
})
